// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isThursday as fn } from "../isThursday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isThursdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isThursdayWithOptions;
